import { DicomMetadataStore } from '@ohif/core';
import React, { useState, useEffect } from 'react';
import SendDicomSerie from '../button/DicomSendSerie';

const ExportInstances = ({ studyMetadata }: { studyMetadata: string }) => {
  const [showModal, setShowModal] = useState(false);
  const [study, setStudy] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Cargar el estudio desde el store de OHIF
    const fetchStudy = async () => {
      try {
        const fetchedStudy = DicomMetadataStore.getStudy(studyMetadata);

        if (fetchedStudy && fetchedStudy.isLoaded) {
          console.log(fetchedStudy.series);
          setStudy(fetchedStudy);
        } else {
          console.warn('Estudio no encontrado o no cargado aún');
        }
      } catch (error) {
        console.error('Error al cargar el estudio:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStudy();
  }, [studyMetadata]);

  if (loading) {
    return <div className="p-4 text-white">Cargando datos del estudio...</div>;
  }

  if (!study) {
    return <div className="p-4 text-red-400">No se encontró información del estudio.</div>;
  }

  const seriesList = study.series || [];

  return (
    <div className="w-full">
      <button
        onClick={() => setShowModal(true)}
        className="hover:text-secondary-light flex h-full w-full justify-center rounded bg-transparent py-2 text-white"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          className="bi bi-send-arrow-up h-4 w-4 sm:h-8 sm:w-8"
          viewBox="0 0 16 16"
        >
          <path
            fillRule="evenodd"
            d="M15.854.146a.5.5 0 0 1 .11.54l-2.8 7a.5.5 0 1 1-.928-.372l1.895-4.738-7.494 7.494 1.376 2.162a.5.5 0 1 1-.844.537l-1.531-2.407L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM5.93 9.363l7.494-7.494L1.591 6.602z"
          />
          <path
            fillRule="evenodd"
            d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.354-5.354a.5.5 0 0 0-.722.016l-1.149 1.25a.5.5 0 1 0 .737.676l.28-.305V14a.5.5 0 0 0 1 0v-1.793l.396.397a.5.5 0 0 0 .708-.708z"
          />
        </svg>
      </button>

      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-black bg-opacity-60 text-white">
          <div className="bg-secondary-dark max-w-2xl overflow-auto rounded p-6 shadow-lg sm:w-full">
            <h2 className="mb-4 text-center text-lg font-semibold">
              {study.StudyDescription || 'Estudio sin descripción'}
            </h2>
            <table className="min-w-full bg-white text-left text-sm text-gray-700">
              <thead className="bg-gray-200 text-gray-900">
                <tr>
                  <th className="px-6 py-3">Descripción</th>
                  <th className="px-6 py-3"># Instancias</th>
                  <th className="px-6 py-3">Modalidad</th>
                  <th className="px-6 py-3"></th>
                </tr>
              </thead>
              <tbody>
                {seriesList.map((serie: any, index: number) => (
                  <tr
                    key={serie.SeriesInstanceUID || index}
                    className="border-b hover:bg-gray-100"
                  >
                    <td className="px-6 py-4">{serie.SeriesDescription || 'Sin descripción'}</td>
                    <td className="px-6 py-4">
                      {serie.instances?.length || serie.NumberOfSeriesRelatedInstances || 0}
                    </td>
                    <td className="px-6 py-4">{serie.Modality || 'N/A'}</td>
                    <td className="px-6 py-4">
                      <button
                        onClick={() => console.log('Enviar serie:', serie.SeriesInstanceUID)}
                        className="text-blue-600 hover:text-blue-800"
                      >
                        <SendDicomSerie
                          seriesNumberCont={serie.SeriesNumber?.length || serie.SeriesNumber || 0}
                          studyMetadata={studyMetadata}
                        ></SendDicomSerie>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="mt-4 flex justify-end">
              <button
                onClick={() => setShowModal(false)}
                className="rounded bg-gray-600 px-4 py-2 text-white hover:bg-gray-700"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExportInstances;
